import {Inject, Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApi, BASE_URL } from '@edl-development/edl-common';
import { WalkthroughObservationModel } from '../model/observation/walkthrough-details.model';
import { ObservationSummaryDTO } from '../model/observation/observation-summary-dto.model';

@Injectable()
export class WalkthroughApi extends BaseApi {

    constructor(
      @Inject(BASE_URL) private baseUri: string,
      private http: HttpClient
    ) {
        super();
    }

    getObservationDetails(userId:string, observationId:string) {
      return this.http.get<WalkthroughObservationModel>(this.baseUri + '/observation/walkthrough/'+observationId, {});
    }

    createWalkthrough(observation: WalkthroughObservationModel){
      return this.http.post<ObservationSummaryDTO>(this.baseUri + '/observation/walkthrough/create', observation);
    }

    deleteWalkthrough(userId:string, observationId:string){
      return this.http.put(this.baseUri + '/observation/walkthrough/delete/' + observationId, {});
    }

    reinstateWalkthrough(userId:string, observationId:string){
      return this.http.put(this.baseUri + '/observation/walkthrough/reinstate/' + observationId, {});
    }

    submitWalkthrough(observationId:string){
      return this.http.put(this.baseUri + '/observation/walkthrough/' + observationId + '/submit', {});
    }
}
